// Bold shared modal for the document workflow. Slightly heavier than
// the rest of the app's chrome — these modals interrupt the doctor
// mid-flow and need to feel decisive, not incidental.

export default function Modal({ title, subtitle, onClose, children, wide = false, narrow = false }) {
  const w = narrow ? 'max-w-sm' : wide ? 'max-w-2xl' : 'max-w-md'
  return (
    <div
      className="fixed inset-0 z-50 bg-slate-900/60 flex items-center justify-center p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.() }}
    >
      <div className={`bg-white rounded-xl shadow-2xl ${w} w-full max-h-[90vh] overflow-y-auto`}>
        <div className="px-5 py-4 border-b-2 border-slate-100 flex items-start justify-between gap-3 sticky top-0 bg-white">
          <div>
            <h3 className="font-bold text-slate-900 text-lg leading-tight">{title}</h3>
            {subtitle && <div className="text-sm text-slate-500 mt-0.5">{subtitle}</div>}
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full w-8 h-8 flex items-center justify-center text-2xl leading-none transition"
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="p-5">
          {children}
        </div>
      </div>
    </div>
  )
}

export function Field({ label, hint, children }) {
  return (
    <div className="mb-4">
      <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 mb-1.5">{label}</label>
      {children}
      {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
    </div>
  )
}

export function ModalActions({ children }) {
  return (
    <div className="flex justify-end gap-2 mt-5 pt-4 border-t-2 border-slate-100">
      {children}
    </div>
  )
}

export function PrimaryButton({ children, onClick, disabled, type = 'button' }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="text-sm font-semibold bg-wantok-700 hover:bg-wantok-800 disabled:bg-slate-300 disabled:cursor-not-allowed text-white rounded-lg px-5 py-2 transition shadow-sm"
    >
      {children}
    </button>
  )
}

export function SecondaryButton({ children, onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 disabled:text-slate-300 disabled:cursor-not-allowed rounded-lg px-4 py-2 transition"
    >
      {children}
    </button>
  )
}
